// extracted by mini-css-extract-plugin
module.exports = {"small":"AntField_small__2dvlX","dscExtend":"AntField_dscExtend__1eQbF","ant-form-item-label":"AntField_ant-form-item-label__1fAvl"};